import { Chip, type ChipProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier atom
 *
 * Compact label pill used for status tags, plan-tier labels, and similar
 * inline metadata. Variant + color choose the visual treatment from the
 * theme; never pass `sx` for color or border.
 *
 * The green "Growth" pill in the upgrade-options card uses
 * `color="success"` + `variant="filled"` + `size="small"`.
 */
export type VyChipProps = ChipProps;

export const VyChip = forwardRef<HTMLDivElement, VyChipProps>(
  function VyChip(props, ref) {
    return <Chip ref={ref} {...props} />;
  },
);
